import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { svgIcon } from '../../Functions';
import { withRouter } from './withRouter';
import { GetNavigations } from '../../Functions/functions';
import { clickable } from '../../Functions/keyboard';

class Sidebar extends Component {

    sidebarRef = React.createRef();

    componentDidUpdate(prevProps) {
        const box = this.sidebarRef.current;
        if (!box || prevProps.isSidebarOpen === this.props.isSidebarOpen) return;
        if (this.props.isSidebarOpen) {
            const first = box.querySelector('[role="button"], a[href]');
            if (first) setTimeout(() => first.focus({ preventScroll: true }), 50);
        } else if (box.contains(document.activeElement)) {
            const menuBtn = document.querySelector('header [aria-label="Menu"], header [title="Menu"]');
            if (menuBtn) menuBtn.focus();
            else document.activeElement.blur();
        }
    }

    state = { openItems: {} };

    toggleItem = (key) => {
        this.setState(({ openItems }) => ({
            openItems: { ...openItems, [key]: !openItems[key] },
        }));
    };

    gotoPage(pageNo) {
        const { router, pdf, isPublish, com_slug } = this.props;
        const { navigate } = router;

        const { pdfSlug } = pdf;

        pageNo = Number(pageNo);

        var Url = `/${pdfSlug}/page/${pageNo}?scroll=true`;

        if (isPublish && com_slug) {
            Url = `/${com_slug}/${pdfSlug}/page/${pageNo}?scroll=true`;
        }


        navigate(Url);
        this.props.toggleSidebar();
    }

    renderItems = (items, depth = 0, parentKey = 'm') => {
        if (!Array.isArray(items)) return null;

        return items.map((item, i) => {
            const key = `${parentKey}_${i}`;
            const hasChildren = Array.isArray(item.children) && item.children.length > 0;
            const isOpen = hasChildren && !!this.state.openItems[key];

            if (!hasChildren) {
                return (
                    <li key={key}>
                        <span className="title" {...clickable(() => this.gotoPage(item.pageNo))}>
                            {item.title}
                        </span>
                    </li>
                );
            }

            const isTop = depth === 0;
            const liClass = (isTop ? 'hasChild' : 'hassubChild') + (isOpen ? ' open' : '');
            const toggle = () => this.toggleItem(key);

            return (
                <li key={key} className={liClass}>
                    <span className="title" {...clickable(toggle)} aria-expanded={isOpen}>
                        {item.title}
                    </span>
                    <span
                        className={isTop ? 'accordion-arrow' : 'accordion-subarrow'}
                        onClick={toggle}
                        aria-hidden="true"
                    >
                        {svgIcon('ico-arrowRight')}
                    </span>
                    <ul className={isTop ? 'accordion-child' : 'accordion-sub-child'}>
                        {this.renderItems(item.children, depth + 1, key)}
                    </ul>
                </li>
            );
        });
    };

    _render = () => this.renderItems(this.props.menuData);

    render() {
        const sidebarClass = this.props.isSidebarOpen ? 'app-sidebar open' : 'app-sidebar';

        return (
            <div className={sidebarClass} ref={this.sidebarRef} aria-hidden={!this.props.isSidebarOpen}>
                <div className="scrollable-list privacyCookieSidebarMain">

                    <ul className="accordion">
                        {this._render()}
                    </ul>

                    {(this.props.cookiePolicyData || this.props.privacyPolicyData) && (
                        <ul className="accordion forPrivacyPolicyMain">
                            {
                                this.props.privacyPolicyData && (
                                    <li>
                                        <span className="title">
                                            <Link to={GetNavigations("/privacy")}>Privacy Policy</Link>
                                        </span>
                                    </li>
                                )
                            }
                            {
                                this.props.cookiePolicyData && (
                                    <li>
                                        <span className="title">
                                            <Link to={GetNavigations("/cookie")}>Cookie Policy</Link>
                                        </span>
                                    </li>
                                )
                            }

                        </ul>
                    )}

                </div>
            </div>
        );
    }
}

export default withRouter(Sidebar);
